import { render, staticRenderFns } from "./RealityCheck.vue?vue&type=template&id=043df0d5&scoped=true&"
import script from "./RealityCheck.vue?vue&type=script&lang=ts&"
export * from "./RealityCheck.vue?vue&type=script&lang=ts&"
import style0 from "./RealityCheck.vue?vue&type=style&index=0&id=043df0d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043df0d5",
  null
  
)

export default component.exports